import React, { Component } from 'react';
import {Route} from 'react-router-dom';
import './reset.css';
import './App.css';

import {
  ViewLogin,
  ViewMain,
  ViewCourse,
  ViewPlayer,
  ViewEvent,
  ViewTalk,
  ViewWebview,
  ViewProfile,
  ViewReport,
  ViewRecuperarSenha,
  ViewCriarNovaSenha
} from './views';

class App extends Component {
  render() {
    return (
      <div id="root" className="rdp-covid-19">
        <Route exact={true} path="/" component={ViewLogin}/>
        <Route exact={true} path="/login" component={ViewLogin}/>
        <Route exact={true} path="/recuperar-senha" component={ViewRecuperarSenha}/>
        <Route exact={true} path="/criar-nova-senha/:token" component={ViewCriarNovaSenha}/>
        <Route exact={true} path="/perfil" component={ViewProfile}/>
        <Route exact={true} path="/feed" component={ViewMain}/>
        <Route exact={true} path="/relatorios" component={ViewReport}/>
        <Route exact={true} path="/curso/:courseUid/:registerUid" component={ViewCourse}/>
        <Route exact={true} path="/evento/:id" component={ViewEvent}/>
        <Route exact={true} path="/palestra/:id" component={ViewTalk}/>
        <Route exact={true} path="/webview/:id" component={ViewWebview}/>
        <Route exact={true} path="/player/:courseUid/:registerUid/:moduleUid/:activityUid" component={ViewPlayer}/>
      </div>
    );
  }
}

export default App;
